import type { GpsPeer } from './gpsPeer';

type Listener = () => void;

const peers = new Map<string, GpsPeer>();
const listeners = new Set<Listener>();

/** In-memory remote GPS peers — populated by M3 Supabase subscribe; empty by default. */
export function getRemoteGpsPeers(): GpsPeer[] {
  return Array.from(peers.values());
}

export function upsertRemoteGpsPeer(peer: GpsPeer): void {
  const existing = peers.get(peer.id);
  if (existing && existing.lastKnownAt >= peer.lastKnownAt) {
    return;
  }
  peers.set(peer.id, peer);
  listeners.forEach((cb) => cb());
}

export function clearRemoteGpsPeers(): void {
  if (peers.size === 0) {
    return;
  }
  peers.clear();
  listeners.forEach((cb) => cb());
}

export function onRemoteGpsPeersChange(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
